import React from "react";
import * as Sentry from "@sentry/react";
import Header from "./Header";
class GlobalErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, { extra: errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <>
          <Header /> <h1>Something went wrong.</h1>
        </>
      );
    }
    return this.props.children;
  }
}

export default GlobalErrorBoundary;
